import React from 'react';

const METRICS = [
  { value: '120,000+', label: 'Farmers Reached' },
  { value: '200+', label: 'Farms Financed' },
  { value: '$15B', label: 'Agriculture Product Value' },
  { value: '99%', label: 'Platform Uptime' },
];

function ImpactMetrics() {
  return (
    <>
      <section className="page-hero">
        <h1>Impact Metrics</h1>
        <p>Our platform's measurable impact on farmers, suppliers, and communities.</p>
      </section>

      <section className="stats-section">
        <div className="stats-grid">
          {METRICS.map((m, i) => (
            <div key={i} className="stat-item">
              <div className="stat-number">{m.value}</div>
              <div className="stat-label">{m.label}</div>
            </div>
          ))}
        </div>
      </section>

      <div className="page-content">
        <div className="page-image">
          <img src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800&q=80" alt="Agricultural impact" />
        </div>
        <h2>Our Impact</h2>
        <p>AGRO-INVEST is committed to measurable outcomes. We track farmer registrations, input financing disbursements, voucher redemptions, and investor participation to ensure our platform delivers real value.</p>

        <h2>Key Metrics</h2>
        <ul>
          <li><strong>Farmer Onboarding:</strong> WhatsApp-based registration and farm data collection</li>
          <li><strong>AI Risk Evaluation:</strong> Farms assessed within 10 seconds</li>
          <li><strong>Voucher Financing:</strong> Digital vouchers for seeds, fertilizer, livestock feed</li>
          <li><strong>Investment Tracking:</strong> Transparent farm listings with risk ratings and expected returns</li>
        </ul>

        <h2>Future Goals</h2>
        <p>We are building toward satellite monitoring, insurance integration, and USSD farmer access to expand our reach and impact.</p>
      </div>
    </>
  );
}

export default ImpactMetrics;
